import React, { useState, useEffect } from "react";
import { Box, TextField, Button, Icon, Snackbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useFormik } from "formik";
import * as yup from "yup";
import { apiUrl } from "../common";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  form: {
    //maxWidth: 396,
    margin: "0 auto",
    //boxShadow: "0 10px 24px 0 rgba(54, 61, 77, 0.15)",
    border: "1px solid #d9d9d9",
    backgroundColor: "#fff",
    color: "#333",
    fontSize: 14,
  },
  close: {
    position: "absolute",
    top: 8,
    right: 8,
    padding: 5,
    background: "#0000000d",
    cursor: "pointer",
  },
  header1: {
    fontSize: 24,
    fontWeight: "bold",
  },
  header2: {},
  button: {
    "&:hover": {
      "box-shadow": "0 0 6px silver",
    },
    fontSize: 16,
    fontWeight: "bold",
  },
  dark: {
    color: "#333",
    borderColor: "#333",
  },
  light: {
    color: "#fff",
    borderColor: "#fff",
  },
}));

const Contact = (props) => {
  const classes = useStyles();
  const model = props.model;
  const [open, setOpen] = useState(false);

  useEffect(() => {}, []);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleClose = () => {
    window.parent.postMessage(
      { type: "form", key: "close", value: { id: model.id } },
      "*"
    );
  };

  const getValidationSchema = (type) => {
    if (type == "Email")
      return yup
        .string()
        .email("Email không hợp lệ")
        .required("Vui lòng nhập email");

    if (type == "Phone")
      return yup
        .string()
        .max(15, "Số điện thoại không hợp lệ")
        .required("Vui lòng nhập số điện thoại");

    return yup.string().required();
  };
  let validSchema = {};
  if (model.formFields.findIndex((x) => x.active && x.name == "Email") != -1)
    validSchema["Email"] = getValidationSchema("Email");
  if (model.formFields.findIndex((x) => x.active && x.name == "Phone") != -1)
    validSchema["Phone"] = getValidationSchema("Phone");
  //console.log(validSchema);
  const formik = useFormik({
    initialValues: { FullName: "", Phone: "", Email: "", Message: "" },
    validationSchema: yup.object().shape(validSchema),
    onSubmit: (values, { resetForm }) => {
      //alert(JSON.stringify(values, null, 2));
      let param = {
        ...values,
        wid: model.parent?.wid ?? "wid",
        uid: model.parent?.uid,
        location: model.parent?.location,
      };
      fetch(`${apiUrl}/api/public/submitform/${model.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...param,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.success) {
            setOpen(true);
            resetForm();
            setTimeout(() => {
              handleClose();
            }, 3000);
          }
        });
    },
  });
  //console.log(formik.errors);
  return (
    <Box
      className={classes.form}
      style={{
        position: "relative",
        padding: model.size == "normal" ? 48 : 32,
      }}
    >
      <Icon className={classes.close} onClick={handleClose}>
        close
      </Icon>
      <Box className={classes.header1}>{model.header1}</Box>
      <Box
        className={classes.header2}
        my={2}
        display="flex"
        alignItems="center"
      >
        <Icon fontSize={model.size == "normal" ? "large" : "default"}>
          mail
        </Icon>
        <Box ml={1}>{model.header2}</Box>
      </Box>
      <form onSubmit={formik.handleSubmit}>
        {model.formFields
          .filter((x) => x.active)
          .map((item, index) => (
            <TextField
              key={index}
              fullWidth
              variant={model.variant}
              margin={model.size == "normal" ? "normal" : "dense"}
              multiline={item.name == "Message"}
              rowsMax={3}
              //required={item.name == "Phone" || item.name == "Email"}
              id={item.name}
              name={item.name}
              label={item.label}
              value={formik.values[item.name]}
              onChange={formik.handleChange}
              error={
                formik.touched[item.name] && Boolean(formik.errors[item.name])
              }
              helperText={formik.touched[item.name] && formik.errors[item.name]}
            />
          ))}
        <Box mt={2}>
          <Button
            size={model.size == "normal" ? "medium" : "small"}
            color="primary"
            variant="contained"
            fullWidth
            type="submit"
            className={classes.button}
            style={{
              borderRadius: model.variant == "standard" ? 0 : 4,
              backgroundColor: model.ctaColor,
            }}
          >
            {model.callToAction ?? "Submit"}
          </Button>
        </Box>
      </form>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          Gửi thành công!
        </Alert>
      </Snackbar>
    </Box>
  );
};
export default Contact;
